import { useEffect, useRef } from 'react';
import { useToast } from '../context/ToastContext';

const DEBOUNCE_MS = 3000;

/**
 * Показывает toast при сетевых ошибках (диспатч из api/client interceptor).
 */
const NetworkErrorListener = () => {
  const { showError } = useToast();
  const lastShownRef = useRef(0);

  useEffect(() => {
    const handler = () => {
      const now = Date.now();
      if (now - lastShownRef.current < DEBOUNCE_MS) return;
      lastShownRef.current = now;
      showError('Нет связи с сервером. Проверьте подключение к сети.');
    };
    window.addEventListener('api:network-error', handler);
    return () => window.removeEventListener('api:network-error', handler);
  }, [showError]);

  return null;
};

export default NetworkErrorListener;
